import { SVGInterface } from "../../interface";

const Warning = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M21.2659 20.9981H2.73288C2.37562 20.9981 2.04551 20.8075 1.86688 20.4981C1.68825 20.1887 1.68825 19.8075 1.86688 19.4981L11.1329 3.49811C11.3117 3.18923 11.6415 2.99902 11.9984 2.99902C12.3553 2.99902 12.6851 3.18923 12.8639 3.49811L22.1299 19.4981C22.3084 19.8074 22.3085 20.1883 22.1301 20.4977C21.9518 20.807 21.622 20.9977 21.2649 20.9981H21.2659ZM11.9999 5.99811L4.46888 18.9981H19.5329L11.9999 5.99811ZM12.9949 14.9991H10.9949V9.99811H12.9949V14.9991Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M10.9999 16.0001H12.9999V18.0001H10.9999V16.0001Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Warning;
